import React from 'react';
import { motion } from 'framer-motion';
import { Check, Scale, Shield, Users, Building2 } from 'lucide-react';

const ServiceAbout = () => {
  return (
    <section id="about" className="py-20 md:py-28" style={{ backgroundColor: '#f4f4f4' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-black" style={{ color: '#1A1A1A' }}>
            About Us
          </h2>
          <div className="mt-4 mx-auto w-20 h-1 rounded-full" style={{ backgroundColor: '#2B2BFF' }} />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-16 items-center">

          {/* Left Column - Logo Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex justify-center"
          >
            <div className="relative">
              <div
                className="absolute inset-0 rounded-2xl blur-2xl opacity-20"
                style={{ backgroundColor: '#2B2BFF', transform: 'scale(0.9)' }}
              />
              <img
                src="/logo.png"
                alt="Namorisatya Legal & Associates"
                className="relative rounded-2xl w-full max-w-lg object-contain"
                style={{ filter: 'drop-shadow(0 20px 40px rgba(43,43,255,0.15))' }}
              />
            </div>
          </motion.div>

          {/* Right Column - Text */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            <p
              className="text-xs font-bold tracking-wider uppercase"
              style={{ color: '#2B2BFF' }}
            >
              WHO WE ARE
            </p>

            <h3
              className="text-3xl md:text-4xl font-black leading-tight"
              style={{ color: '#1A1A1A' }}
            >
              Legal Service That<br />Can't Be Matched
            </h3>

            <p className="text-base leading-relaxed" style={{ color: '#555555' }}>
              <strong style={{ color: '#1A1A1A' }}>Namorisatya Legal & Associates</strong> is a full-service law firm
              committed to providing comprehensive, practical, and result-oriented legal solutions to individuals,
              businesses, and organizations. Built on a foundation of integrity, professionalism, and excellence,
              the firm strives to deliver high-quality legal services tailored to the specific needs of each client.
            </p>

            <p className="text-base leading-relaxed" style={{ color: '#555555' }}>
              Led by <strong style={{ color: '#1A1A1A' }}>Advocates Rupam Kumari and Abhyant Patel</strong>,
              we believe that effective legal representation goes beyond knowledge of the law — it requires a deep
              understanding of our clients' goals, challenges, and priorities. Our approach is client-focused and
              solution-driven, ensuring that every matter is handled with diligence, strategic insight, and
              attention to detail.
            </p>

            <p className="text-base leading-relaxed" style={{ color: '#555555' }}>
              We represent clients before the <strong style={{ color: '#1A1A1A' }}>Supreme Court of India,
              Patna High Court, Delhi High Court, Allahabad High Court, Jharkhand High Court</strong> and
              all District Courts across India. The firm is also <strong style={{ color: '#1A1A1A' }}>empaneled
              with leading NBFCs</strong> for legal retainership and recovery matters. Our mission is to provide
              reliable legal guidance and strong representation while upholding the highest standards of the
              legal profession.
            </p>

            {/* Feature Points */}
            <div className="space-y-4 pt-2">
              {[
                { icon: Scale, text: 'Expert Criminal & Civil Legal Representation' },
                { icon: Shield, text: 'Client-Focused & Result-Oriented Strategy' },
                { icon: Users, text: 'Personalized Attention for Every Client' },
                { icon: Check, text: 'Practicing Before Supreme Court & All Major High Courts' },
                { icon: Building2, text: 'Empaneled with Leading NBFCs for Legal Retainership' },
              ].map(({ icon: Icon, text }) => (
                <div key={text} className="flex items-center space-x-3">
                  <div
                    className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: '#2B2BFF' }}
                  >
                    <Icon className="h-4 w-4 text-white" strokeWidth={2.5} />
                  </div>
                  <p className="text-base font-semibold" style={{ color: '#1A1A1A' }}>
                    {text}
                  </p>
                </div>
              ))}
            </div>

          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default ServiceAbout;